import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';


export class Order {
  number: string;
  createdAt: string;

}

@Injectable()
export class TaskService {

  

  constructor(private db: AngularFireDatabase) { }

  // Run task relative to current time
  performIn(time: number, worker: string, opts = {}) {
    const queueRef = this.db.list('tasks'); 

    time = new Date().getTime() + time
    queueRef.push({ time, worker, opts });
  }

  // Run task at a specific time
  performAt(time: number, worker: string, opts = {}) {
    const queueRef = this.db.list('tasks');
    
    queueRef.push({ time, worker, opts });
  }

  // Run task at a specific time
  updateTaskAt(uid:string, time: number, worker: string, opts = {}) {
    const taskRef = this.db.object(`tasks/${uid}`);
    
    taskRef.update({ time, worker, opts });
  }

  // Schedule recurring tasks
  performPeriodic(id: string, time: number, interval: number, worker: string, opts = {}) {
    const taskRef = this.db.object(`tasks/${id}`);
    
    taskRef.set({ time, interval, worker, opts });
  }

  // Schedule recurring tasks
  deleteTask(id: string) {   
    this.db.object('/tasks/' + id).remove();
  }

  getScheduledOrders(){
    return this.db.list('tasks');
  }

}